import styled from 'styled-components';
import {
    Title,
    Subtitle,
} from 'src/pages/scheduleSurgery/components/surgery/SurgeryReviewAndSuccess.styled';
import media from 'src/styles/Media.styled';

export const ProcedureDetailsTitle = styled(Title)`
    line-height: 20px;
`;

export const DetailsMainContainerBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'space-between'};

    ${media.mobileDevice`
        width: 100%;
        margin: 0px auto;
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : ' ')};
    `}
`;
export const MainContainerItems = styled.div`
    width: ${({ fullWidth }) => (fullWidth ? '100%' : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};

    ${media.mobileDevice`
        width: 100%;
        margin-bottom: ${({ mbMarginBottom }) => mbMarginBottom};
    `}
`;

export const UnIdContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
`;

export const ProcedureDetailsSubTitle = styled(Subtitle)`
    line-height: 20px;
    font-size: 15px;
    color: ${({ isUnIdNo }) => isUnIdNo && '#1010EB'};
    font-family: ${({ isUnIdNo }) =>
        isUnIdNo ? 'AvenirNextWorld Demi' : 'AvenirNextWorld Regular'};
`;

export const UNiDSpan = styled.span`
    &:before {
        content: '|';
        margin: 0 5px;
    }
`;
